import * as React from 'react'

const Header = ({ currentStep }) => {
  const steps = [
    { number: 1, name: 'Abstract Type' },
    { number: 2, name: 'Author / Co-authors' },
    { number: 3, name: 'Abstract Content' },
    { number: 4, name: 'Preview & Confirm Submission' },
  ]

  return (
    <div className="flex flex-col space-y-10 items-center w-full">
      {/* Step Indicator - Only show when currentStep > 0 */}
      {currentStep > 0 && (
        <div className="flex space-x-8 items-start w-full">
          {steps.map((step, index) => (
            <div key={step.number} className="flex flex-col space-y-4 flex-1">
              <div
                className={`h-1 w-full ${
                  currentStep >= step.number ? 'bg-blue-900' : 'bg-gray-200'
                }`}
              />
              <div className="flex flex-col">
                <p
                  className={`text-xs font-semibold leading-4 uppercase tracking-wide ${
                    currentStep >= step.number ? 'text-blue-900' : 'text-gray-500'
                  }`}
                >
                  Step {step.number}
                </p>
                <p className="text-sm font-normal leading-5 text-gray-900">{step.name}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Header
